// extracted by mini-css-extract-plugin
module.exports = {"item-text":"secondary-page_item-text__3DqIw","bold-text":"secondary-page_bold-text__3Eweh","text-22":"secondary-page_text-22__1pTrh","mail-text":"secondary-page_mail-text__1bgnI"};